import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { "data-qa": "skeleton-blog-post-list" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itemsCount, (item) => {
      return (_openBlock(), _createElementBlock("div", { key: item }, [
        _createVNode(_component_skeleton_wrapper, {
          "has-animation": true,
          class: "_mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_skeleton_line, {
              height: 40,
              class: "gfu-animation-pulse"
            }),
            _createVNode(_component_skeleton_line, {
              height: 15,
              class: "gfu-animation-pulse _mt-1"
            }),
            _createVNode(_component_skeleton_line, {
              height: 20,
              class: "gfu-animation-pulse _mt-2"
            }),
            _createVNode(_component_skeleton_line, {
              height: 14,
              class: "gfu-animation-pulse _mt-2"
            })
          ]),
          _: 1 /* STABLE */
        })
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}